import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useSelected } from '../company/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useExport = () => {
  const { selectedCompanyId: companyId } = useSelected();
  const { mutate: mutateExport } = useAppMutation([QueryKey.EXPORT_EVENTS, companyId], {
    mutationFn: async () => {
      await ApiService.downloadFile({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'safes', 'export'],
      });
    },
  });

  return { mutateExport };
};
